import { render, staticRenderFns } from "./FileListSkeleton.vue?vue&type=template&id=bcac3a52"
import script from "./FileListSkeleton.vue?vue&type=script&lang=js"
export * from "./FileListSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports